import { combineReducers } from 'redux';
import commonReducer from '../reducers/commonReducer';
import userConnectReducer from '../reducers/userConnectReducer';
import userAccountWizardReducer from '../reducers/userAccountWizardReducer';
import adUnitControlPanelReducer from '../reducers/gdUnitControlPanelReducer';
import widgetReducer from '../reducers/widgetReducer';
import dataPublicReducer from '../reducers/dataPublicReducer'

export default combineReducers({
    userConnectReducer,
    commonReducer,
    userAccountWizardReducer,
    adUnitControlPanelReducer,
    widgetReducer,
    dataPublicReducer
});



// WEBPACK FOOTER //
// ./src/reducers/rootReducer.js